enum OrdenationTypeEnum {
  ASC = 'ASC',
  DESC = 'DESC',
}

export default OrdenationTypeEnum;
